<template>
  <div>
    <iframe
      id="iframeSofaScore"
      width="100%"
      height="154"
      frameborder="0"
      scrolling="no"
      :src="
        'https://www.sofascore.com/pt/evento/' +
        $route.params.idEvento +
        '/attack-momentum/inserir'
      "
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "Sofascore",
  components: {},
  props: {},
  methods: {},
};
</script>

<style scoped>
@media (min-width: 1px) and (max-width: 239px) {
  #iframeSofaScore {
    width: 100%;
    border: none;
    position: relative;
    top: -39px;
    height: 300px;
  }
}
@media (min-width: 240px) and (max-width: 280px) {
  #iframeSofaScore {
    width: 100%;
    border: none;
    position: relative;
    top: -39px;
    height: 300px;
  }
}
@media (min-width: 281px) and (max-width: 364px) {
  #iframeSofaScore {
    width: 100%;
    border: none;
    position: relative;
    top: -39px;
    height: 300px;
  }
}

@media (min-width: 365px) and (max-width: 416px) {
  #iframeSofaScore {
    width: 100%;
    border: none;
    position: relative;
    /*top: -79px;*/
    top: -39px;
    height: 300px;
  }
}
/*365 416*/
@media (min-width: 417px) and (max-width: 543px) {
  #iframeSofaScore {
    width: 100%;
    border: none;
    position: relative;
    top: -39px;
    height: 300px;
  }
}
@media (min-width: 544px) {
  #iframeSofaScore {
    width: 100%;
    border: none;
    position: relative;
    top: -39px;
    height: 300px;
  }
}
</style>